module.exports = __webpack_public_path__ + "img/top-banner.ce67c9f3.png";